import { Directive, ElementRef, EventEmitter, Output, Self } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { Subject, fromEvent, merge, takeUntil } from 'rxjs';

@Directive({
  selector: 'mat-option[disableMatOptionSelection]',
  standalone: true,
})
export class DisableMatOptionSelectionDirective {

  readonly #destroy = new Subject<void>()

  @Output('selectionChanged')
  readonly selectionChangedEv = new EventEmitter<any>()

  constructor(
    @Self()
    private readonly _option: MatOption,
    private readonly _elementRef: ElementRef<HTMLElement>
  ) {

  }


  ngOnInit() {

    this._option.onSelectionChange.complete()
    this._option._handleKeydown = (ev) => {
      if (ev.key === 'Enter') {
        this.selectionChangedEv.emit(this._option.value)
      }
    }
  }

  ngAfterViewInit() {

    merge(
      fromEvent(this._elementRef.nativeElement, 'click')
    )
      .pipe(takeUntil(this.#destroy))
      .subscribe(() => {
        this.selectionChangedEv.emit(this._option.value)
      })


  }



  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
